import script from "./AccountingTree.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountingTree.vue?vue&type=script&setup=true&lang=js"

import "./AccountingTree.vue?vue&type=style&index=0&id=6c5ac35f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c5ac35f"]])

export default __exports__